<template lang="pug">
.activity-score(:class="scoreClass")
  | {{ scoreValueString }}
</template>

<script>
import { INSIGHTS } from '~/app_constants';

export default {
  name: 'InsightsActivityScore',
  props: {
    score: {
      type: Number,
      required: false,
      default: null,
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium'].includes(value),
    },
    upperThreshold: {
      type: Number,
      default: 50,
    },
    lowerThreshold: {
      type: Number,
      default: 20,
    },
    // If true, higher scores are better. If false, lower scores are better.
    // Being classnames with high = good = green, medium = ok = yellow/orange, low = bad = red
    higherIsPositive: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ratingClassForHigherIsPositive() {
      if (this.score > this.upperThreshold) {
        return 'high';
      }
      
      if (this.score > this.lowerThreshold) {
        return 'medium';
      }

      return 'low';
    },
    ratingClassForLowerIsPositive() {
      if (this.score < this.lowerThreshold) {
        return 'high';
      }
      
      if (this.score < this.upperThreshold) {
        return 'medium';
      }

      return 'low';
    },
    scoreClass() {
      const size = `activity-score-${this.size}`;

      if (this.score == null) {
        return `activity-none ${size}`;
      }

      const rating = this.higherIsPositive
        ? this.ratingClassForHigherIsPositive
        : this.ratingClassForLowerIsPositive;

      return `activity-${rating} ${size}`;
    },
    scoreValueString() {
      return this.score != null ? `${Math.round(this.score)}%` : INSIGHTS.empty_states.no_data.no_data_symbol;
    },
  },
};
</script>
